import { h, Component } from 'preact';
/* eslint-disable no-unused-vars */
import { PreactHTMLConverter } from 'preact-html-converter';
import _ from 'lodash';
import { getSectionData } from './utils/chart-utils';

// components
import Portal from './components/Portal';
import TimelineChart from './components/TimelineChart';
import MiniChart from './components/MiniStepChart';

// data
import data from '../../data/data.json'; // Weekly data
import text from '../../data/text.json'; // Text data

const converter = PreactHTMLConverter();

class Timeline extends Component {
  constructor() {
    super();
  }

  componentDidMount() {}

  render() {
    let weeklyDataSections = getSectionData(data);

    return (
      <div>
        <Portal node={document.getElementById('year-of-deaths-chart')}>
          <div class="chart-container">
            {/* This is the scrollytelling chart */}
            <h2 class="chart_title">
              {converter.convert(text['weekly-deaths-chart-headline'])}
            </h2>
            <div class="scroller-container">
              <TimelineChart
                week_data={weeklyDataSections}
              />
            </div>
            <ul class="graphic-footer">
  <li>{converter.convert(text['source_text'])}</li></ul>
          </div>
        </Portal>
        {/* April - June 2020 Timeline charts */}
        <Portal node={document.getElementById('april-june-chart-mini-charts')}>
        <div class="c-plugin c-plugin--narrow c-plugin--side c-plugin--default c-plugin--flush c-plugin--chart">
<div class="c-plugin__inner c-plugin__inner--right c-plugin__inner--offset">
          <div class="mini-charts-grid-container has-page-padding">
            <MiniChart
              section={'Spring2020Chart'}
              scale={'weekly_deaths_reported'}
              type={'weekly'}
              data={weeklyDataSections}
            />
            <MiniChart
              section={'Spring2020Chart'}
              scale={'deaths_nursing_homes'}
              type={'total'}
              data={weeklyDataSections}
            />
          </div>
          </div>
</div>
        </Portal>

        {/* Summer and Fall 2020 peak timeline charts */}

        <Portal node={document.getElementById('summer-mini-charts')}>
           <div class="c-plugin c-plugin--narrow c-plugin--side c-plugin--default c-plugin--flush c-plugin--chart">
<div class="c-plugin__inner c-plugin__inner--right c-plugin__inner--offset">
          <div class="mini-charts-grid-container has-page-padding">
            <MiniChart
              section={'SummerPeakChart'}
              scale={'weekly_deaths_reported'}
              type={'weekly'}
              data={weeklyDataSections}
            />
           <MiniChart
              section={'SummerPeakChart'}
              scale={'deaths_nursing_homes'}
              type={'total'}
              data={weeklyDataSections}
            />
          </div>
          </div>
</div>
        </Portal>

        {/* Winter 2020 - 2021 rebound timeline charts */}

        <Portal node={document.getElementById('winter-rebound-mini-charts')}>
           <div class="c-plugin c-plugin--narrow c-plugin--side c-plugin--default c-plugin--flush c-plugin--chart">
<div class="c-plugin__inner c-plugin__inner--right c-plugin__inner--offset">
          <div class="mini-charts-grid-container has-page-padding">
          <MiniChart
              section={'WinterReboundChart'}
              scale={'weekly_deaths_reported'}
              type={'weekly'}
              data={weeklyDataSections}
            />
            <MiniChart
              section={'WinterReboundChart'}
              scale={'deaths_nursing_homes'}
              type={'total'}
              data={weeklyDataSections}
            />
          </div>
          </div>
</div>
        </Portal>

        {/* Spring 2021 after the vaccine timeline charts */}

        <Portal node={document.getElementById('spring2021-mini-charts')}>
           <div class="c-plugin c-plugin--narrow c-plugin--side c-plugin--default c-plugin--flush c-plugin--chart">
<div class="c-plugin__inner c-plugin__inner--right c-plugin__inner--offset">
          <div class="mini-charts-grid-container has-page-padding">
            <MiniChart
              section={'Spring2021Chart'}
              scale={'weekly_deaths_reported'}
              type={'weekly'}
              data={weeklyDataSections}
            />
             <MiniChart
              section={'Spring2021Chart'}
              scale={'deaths_nursing_homes'}
              type={'total'}
              data={weeklyDataSections}
            />
          </div>
          </div>
</div>
        </Portal>
      </div>
    );
  }
}

export default Timeline;
